import { fixUrl, isMagicRequest, getCookieParams, isCommcgiRequest } from './utils';

export default (req) => {
  const request = req;
  const { data = {} } = request.options;
  let { url } = request.options;
  // 补全地址，加上http/https协议
  url = fixUrl(url);
  if (isMagicRequest(url)) {
    // 从TV上扫码下来的场景，会带登录态(以o_开头的参数，在登录插件中，存入了cookie中), 请求时把这些参数透传给后端
    request.options.data = {
      tv_login_flag: 1,
      ...getCookieParams(),
      ...data,
    };
    return request;
  }
  if (isCommcgiRequest(url)) {
    // tv扫码下来的场景，针对commcgi请求，走logan的代理魔方代理，整个流程如下
    // logan的svip_comm_cgi协议（魔方彩云支持互联登录态转换，处理tv登录态和会员登录态的转换）-> 魔方的commcgi透传协议 -> commcgi接口
    // logan的接口wiki http://tapd.oa.com/hollywood/markdown_wikis/show/#1210114921000848161
    const [, search = ''] = url.split('?');
    const svipUrl = '//vip.video.qq.com/fcgi-bin/svip_comm_cgi?svr_name=asyn_activity&magic_trans_type=commcgi';
    request.options.url = `${svipUrl}&${search}`;
    const ckParams = getCookieParams();
    request.options.otype = 'jsonp';
    request.options.data = {
      TvReqType: ckParams.kt_login === 'qq' ? 1 : 2,
      OpenId: ckParams.openid,
      AccessToken: ckParams.access_token,
      VuserId: ckParams.vuserid,
      vUsession: ckParams.vusession,
      Appid: ckParams.appid,
      ...data,
    };
    return request;
  }
  return request;
};
